import { render, staticRenderFns } from "./listCategory.vue?vue&type=template&id=b947e6aa&"
import script from "./listCategory.vue?vue&type=script&lang=js&"
export * from "./listCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports